import { render, staticRenderFns } from "./ConfiguracoesMensageria.vue?vue&type=template&id=45761b32"
import script from "./ConfiguracoesMensageria.vue?vue&type=script&lang=js"
export * from "./ConfiguracoesMensageria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports